import React from 'react'

import { Form, Col } from '_zari/core'

import * as CentroCostoService from 'services/centrosCosto.service'

const InfoCentroCostoFormGroup = ({ iValue }) => {
  const [infoArbol, setInfoArbol] = React.useState('')

  React.useEffect(() => {
    CentroCostoService.obtenerInfoArbolxId(iValue).then(({ data }) => {
      // console.log(data)
      setInfoArbol(data)
    })
  }, [iValue])

  return (
    <Form.Group>
      <Form.Label text='CENTRO COSTO' htmlFor='readonlu-infoArbol' md={2} alignRightAt='md' />
      <Col md={10}>
        <Form.InputText id='readonlu-infoArbol' name='readonlu-infoArbol' disabled value={infoArbol} onChange={() => {}} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(InfoCentroCostoFormGroup)
